import React from 'react'
import { GiftCardModal } from '../../../gift-cards/modal/GiftCardModal'
import { GiftCardPaymentOption, SalePayment } from './types'

type Props = {
  paymentOptions: GiftCardPaymentOption
  onSuccess: (result: SalePayment) => void
  onClose: () => void
}

export const GiftCard = ({ paymentOptions, onSuccess, onClose }: Props) => {
  return (
    <GiftCardModal
      giftCardType="BALANCES"
      flow="REDEEMING"
      amount={paymentOptions.amount}
      paymentType={paymentOptions.paymentType}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  )
}
